import { css } from '@compiled/react';

import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { token } from '@atlaskit/tokens';

import { isLocalizableHref } from '@/libraries/web-framework/src/localization/use-localized-href';

import { DropdownType } from './mobile-nav';
import { MobileNavLinkContentProps } from './mobile-nav-links-container';

const containerCss = css({
	display: 'flex',
	justifyContent: 'space-between',
	paddingBlock: token('space.200'),
});

const headerCss = css({
	textTransform: 'uppercase',
	fontWeight: '400',
	fontSize: '12px',
	lineHeight: '20px',
	paddingBlock: '12px',
});

const hrefCss = css({
	paddingBlock: token('space.200'),
});

const LinkContent = ({ linkText, hasSubnav, href }: MobileNavLinkContentProps) => {
	return (
		<div css={[containerCss, !hasSubnav && !href && headerCss, href && hrefCss]}>
			<span>{linkText}</span>
			{hasSubnav && <ChevronRightIcon label="" spacing="spacious" />}
		</div>
	);
};
interface MobileNavLinkProps extends MobileNavLinkContentProps {
	handleMenuPage: (menuPage: DropdownType | string) => void;
}
export const MobileNavLink = (props: MobileNavLinkProps) => {
	return (
		<>
			{props.href ? (
				<a
					href={props.href}
					target={isLocalizableHref(props.href) ? '' : '_blank'}
					rel={isLocalizableHref(props.href) ? '' : 'noreferrer'}
					aria-label={props.linkText}
					data-event="clicked"
					data-event-component="linkButton"
					data-event-container="navbarDropdown"
					data-label={props.linkText}
				>
					<LinkContent {...props} />
				</a>
			) : props.hasSubnav ? (
				<button
					style={{ all: 'unset', width: '100%', cursor: 'pointer' }}
					onClick={(e) => {
						e.preventDefault();
						if (props.dropdownType !== undefined) props.handleMenuPage(props.dropdownType);
					}}
					data-event="clicked"
					data-event-component="linkButton"
					data-event-container="navbarDropdown"
					data-label={props.linkText}
					data-product-key={props.productKey}
				>
					<LinkContent {...props} />
				</button>
			) : (
				<LinkContent {...props} />
			)}
		</>
	);
};
